module.exports = __webpack_public_path__ + "img/back_body.3e88b47f.svg";